import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Swiper from 'swiper';
import 'swiper/css';
import styles from './index.css';

const SwiperPart = (props) => {
    const { content, currentIndex, setCurrentIndex, setAction } = props;

    useEffect(() => {
        new Swiper('#swiper1', {
            slidesPerView: content.length < 3 ? 2 : 3,
            spaceBetween: 3
        });
    }, []);

    const handlePrev = () => {
        const res = currentIndex - 1;

        if (res < 0) {
            return;
        }

        setCurrentIndex(res);
        setAction('prev');
    };

    const handleNext = () => {
        const res = currentIndex + 1;

        if (res >= content.length) {
            return;
        }

        setCurrentIndex(res);
        setAction('next');
    };

    const handleClick = (index) => {
        setCurrentIndex(index);
        setAction(index > currentIndex ? 'next' : 'prev');
    };

    return (
        <div className={styles.swiperWp}>
            <div className={styles.page}>
                <span>{currentIndex + 1}/{content.length}</span>
            </div>
            <div className={styles.swiper_div} style={{ maxWidth: content.length < 3 ? '299px' : '418px' }}>
                {/* 左箭头 */}
                <div className={`${styles.nav} ${styles.prev}`} id="prev1" onClick={handlePrev}><img src="https://x0.ifengimg.com/ucms/2022_19/7366090BE1D1AD2B03712FF7B767DC77A4B3E61A_size4_w58_h150.png" alt="" /></div>
                <div className="swiper" id="swiper1">
                    <div className="swiper-wrapper">
                        {
                            content.map((item, index) => {
                                return (
                                    <div className="swiper-slide" key={index}>
                                        <div className={`${styles.swiperSlide} ${currentIndex === index ? styles.active : ''}`} onClick={() => handleClick(index)}>
                                            <img src={item.thumbnail} alt="" />
                                        </div>
                                    </div>
                                );
                            })
                        }
                    </div>
                </div>
                {/* 右箭头 */}
                <div className={`${styles.nav} ${styles.next}`} id="next1" onClick={handleNext}><img src="https://x0.ifengimg.com/ucms/2022_19/CC3BAFAE376CE54D3A0F85AF0CFC7D83B9662C0B_size4_w58_h150.png" alt="" /></div>
            </div>
        </div>

    );
};

SwiperPart.propTypes = {
    content: PropTypes.array,
    currentIndex: PropTypes.number,
    setCurrentIndex: PropTypes.func,
    setAction: PropTypes.func
};

export default errorBoundary(SwiperPart);
